import {
  PRIVACY_COOKIES_LINKS,
  WEBSITE_TC_LINKS,
  SECURITY_CENTRE_LINKS,
} from "./Footer.const";

import { brand } from "services/envService";
const BRAND = brand();

type FooterContent = { label: string; title: string; link: string };

const footerContent: FooterContent[] = [
  {
    label: "Privacy & Cookies",
    title: "Privacy & Cookies",
    link: PRIVACY_COOKIES_LINKS[BRAND],
  },
  {
    label: "Website T&Cs & FSCS",
    title: "Website T&Cs & FSCS",
    link: WEBSITE_TC_LINKS[BRAND],
  },
  {
    label: "Security Centre",
    title: "Security Centre",
    link: SECURITY_CENTRE_LINKS[BRAND],
  },
];

export const Footer = () => {
  return (
    <>
      <footer className="flex-rw">
        <div className="footer_container">
          <ul className="footer_Navbar">
            {footerContent.map((item) => (
              <li key={item.label}>
                <a
                  className="footer_LinkAnchor"
                  title={item.label}
                  href={item.link}
                  target="headerWindow"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </footer>
    </>
  );
};
